/**
 * Wraps one or two dates in <strong> tags while preserving or replacing the delimiter.
 *
 * @param dateRange - The date range string (e.g., "August 15 to August 16" or "August 15").
 * @param customDelimiter - Optional delimiter to use instead of the one in the input string.
 * @returns The formatted string with bolded dates.
 */

const formatBoldDateRange = (dateRange: string, customDelimiter?: string): string => {

    if (!dateRange.trim()) return '';

    // Detect delimiter if not provided
	const delimiter = customDelimiter ?? (() => {
		
        const match = dateRange.match(/(\s+[^a-zA-Z0-9]+\s+|\s+to\s+|\s*-\s*)/i);
		return match ? match[0] : '';
		
    })();

    // If no delimiter or not exactly two parts, return single bold value
	if (!delimiter) {
		
		return `<strong>${dateRange.trim()}</strong>`;
		
    }

	const parts = dateRange.split(delimiter);
	
	if (parts.length !== 2) {
		
		return `<strong>${dateRange.trim()}</strong>`;
		
    }

    const [start, end] = parts.map(str => str.trim());
	return `<strong>${start}</strong>${delimiter}<strong>${end}</strong>`;
	
};

export default formatBoldDateRange;